/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
 import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
 import _ from 'lodash'
 import ListPageService from 'src/types/ListPage';
 import override from 'src/dectorators/override';
 import { QueryFormVOI } from 'src/components/queryForm/queryForm';
 import MnManageApi, { MnManageDOI } from '../api/mnmanageApi'
 import MnManageApi from '../api/mnmanageApi'
 import Mnmanage from '../mnmanage';
 import AreaCascader from 'src/components/areaCascader/areaCascader';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumAlarmType from 'src/enums/enumAlarmType';
 import EnumNoticeType from 'src/enums/enumNoticeType';
 import DatePicker from 'src/types/iview/DatePicker';
 import Input from 'src/types/iview/Input';
 import EnumStationType from 'src/enums/enumStationType';
 import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
 import alertMnManageModal from '../mnmanageModal';
 import { Toast } from 'src/util/toast';
 import EnumOperates from 'src/enums/enumOperates';
 
 export default class MnManageService extends ListPageService {
     ctx: Mnmanage;
     
     get type() {
         return EnumStationType.findCode(this.ctx.$route.params.type).getId();
     }
 
     constructor (ctx: Mnmanage) {
         super()
         this.ctx = ctx
     }
 
     @override
     createColumns (): ColDefCustom [] {
         let t = this
         return [
             {
                 headerName: '时间',
                 field: 'create_time',
                 minWidth: 160,
             },
             {
                headerName: 'mn号',
                field: 'mn',
                minWidth: 160,
             },
             {
                headerName: '所属单位',
                field: 'company_unit',
                minWidth: 160,
             },
             {
                headerName: '操作',
                field: 'operate',
                minWidth: 400,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            let res = await alertMnManageModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: SnConfigDOI.RowDataI = params.data;
                            await t.delete(data.mn);
                        },
                    }
                ],
            },
         ]
    }

     @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertMnManageModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete(mn: string) {
        let { code } = await MnManageApi.delete(mn);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }
 
     @override
     creatQueryForm(): QueryFormVOI.DateItemType[] {
         return [
             {
                 component: Input,
                 label: '',
                 labelWidth: 20,
                 width: 140,
                 field: 'key_word',
                 props: { value: '', placeholder: '请输入mn号/所属单位' },
             },
         ];
     }
 
 
     @override
     initSearchParams (): void {
         this.ctx.searchParams = {
             ...this.ctx.queryForm.getQueryObj<MnManageDOI.QueryRowDataParamsI>(),
             page_index: this.ctx.currentPage,
             page_size: this.ctx.pageSize,
         }
         this.ctx.currentPage = 1
     }
 
     @override
     async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await MnManageApi.searchList({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
             page_index: ctx.currentPage
         })
         ag.hideLoading()
 
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count
         }
     }
 
 }
 